import { useEffect } from 'react';

function useChatbotEmbed(
  chatbotUuid: string,
  isTest: boolean,
  setEmbedIsReady: Function,
  chatbotEmbedType?: 'Regular' | 'Full screen',
  isPreview?: boolean
): void {
  const scriptSrc = process.env.REACT_APP_EMBED_CHATBOT_SRC as string;
  const baseUrl = process.env.REACT_APP_BASE_URL as string;

  const isFullWidth = chatbotEmbedType === 'Full screen';

  const createAndAppendIframe = (testMode: boolean): void => {
    const iframe = document.createElement('iframe');
    iframe.setAttribute('id', 'japeto-iframe');
    iframe.setAttribute(
      'src',
      `${baseUrl}/public/chatbots/${chatbotUuid}${testMode ? '?isTest=true' : ''}`
    );
    iframe.style.width = '100vw';
    iframe.style.height = '100vh';
    iframe.style.top = '0';
    iframe.style.left = '0';
    iframe.style.position = 'absolute';
    iframe.setAttribute('frameborder', '0');
    document.body.appendChild(iframe);
  };

  const createAndAppendRootDivAndScript = () => {
    const div = document.createElement('div');
    div.setAttribute('id', 'japeto-root');
    // Lowercase keys keep the attribute names the widget reads (e.g. data-istest, not data-is-test).
    div.dataset.botid = chatbotUuid;
    div.dataset.istest = isTest.toString();
    div.dataset.ignorepathrules = 'true';
    if (isPreview) {
      div.dataset.preview = 'true';
    }
    document.body.appendChild(div);

    const script = document.createElement('script');
    script.src = scriptSrc;
    document.body.appendChild(script);
  };

  useEffect(() => {
    if (!chatbotUuid) return () => {};

    const handleApiReady = (): void => {
      window.japetoApi?.hideChatbot();
      setEmbedIsReady(true);
    };

    window.addEventListener('japetoApiReady', handleApiReady);

    createAndAppendIframe(isTest);
    createAndAppendRootDivAndScript();

    const iframe = document.getElementById('japeto-iframe')!;
    const root = document.getElementById('japeto-root')!;
    iframe.style.display = isFullWidth ? 'block' : 'none';
    root.style.display = isFullWidth ? 'none' : 'block';

    return () => {
      window.removeEventListener('japetoApiReady', handleApiReady);
      setEmbedIsReady(false);
      document.querySelector(`script[src="${scriptSrc}"]`)?.remove();
      document.getElementById('japeto-root')?.remove();
      document.getElementById('japeto-iframe')?.remove();
    };
  }, [chatbotUuid, isTest, scriptSrc, setEmbedIsReady]);

  useEffect(() => {
    const iframe = document.getElementById('japeto-iframe');
    const root = document.getElementById('japeto-root');
    if (!iframe || !root) return;
    iframe.style.display = isFullWidth ? 'block' : 'none';
    root.style.display = isFullWidth ? 'none' : 'block';
  }, [isFullWidth]);
}

export default useChatbotEmbed;
